export default __webpack_public_path__ + "static/media/logoJuicy.8abfe793.png";